import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormLabel from "@mui/material/FormLabel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
const StartTimeConfirmModal = ({
  open,
  onClose,
  onProceed,
  onUpdateStartTime,
  fleetDetails,
  processing = false,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleDialogClose = (event, reason) => {
    if (processing) return;
    if (reason === "backdropClick") return;
    onClose();
  };

  return (
    <div>
      <Dialog
        className="StartTimeConfirmModal"
        fullScreen={fullScreen}
        open={open}
        onClose={handleDialogClose}
        disableEscapeKeyDown={processing}
        aria-labelledby="start-time-confirm-dialog"
      >
        <DialogTitle
          id="start-time-confirm-dialog"
          className="dialog_header ty_form_heading"
          variant="h4"
        >
          {"Confirm Start Times"}
        </DialogTitle>
        <DialogContent>
          <Box
            my={1}
            className="maaz_ahmed_123"
            sx={{
              padding: "0",
            }}
          >
            <Typography variant="p" sx={{ mb: 1 }} className="MuiTypography-p">
              The system is about to process results using the recorded start
              time. Is this information correct?
            </Typography>
          </Box>
          <Box sx={{ padding: "0px" }}>
            <TableContainer
              component={Paper}
              className="ty_table_container"
              sx={{ padding: "0.75rem !important", paddingTop: "0 !important" }}
            >
              <Table
                aria-label="fleet start times table"
                sx={{ borderCollapse: "separate", borderSpacing: "0 6px" }}
              >
                <TableHead>
                  <TableRow sx={{ th: { border: 0 } }}>
                    <TableCell>
                      <FormLabel
                        className="ty-uppercase-label"
                        sx={{
                          display: "inline",
                          width: "auto",
                          marginBottom: "0 !important",
                        }}
                      >
                        FLEET
                      </FormLabel>
                    </TableCell>
                    <TableCell align="center">
                      <FormLabel
                        className="ty-uppercase-label"
                        sx={{
                          display: "inline",
                          width: "auto",
                          marginBottom: "0 !important",
                        }}
                      >
                        HR
                      </FormLabel>
                    </TableCell>
                    <TableCell align="center">
                      <FormLabel
                        className="ty-uppercase-label"
                        sx={{
                          display: "inline",
                          width: "auto",
                          marginBottom: "0 !important",
                        }}
                      >
                        MIN
                      </FormLabel>
                    </TableCell>
                    <TableCell align="center">
                      <FormLabel
                        className="ty-uppercase-label"
                        sx={{
                          display: "inline",
                          width: "auto",
                          marginBottom: "0 !important",
                        }}
                      >
                        SEC
                      </FormLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fleetDetails && fleetDetails.length > 0 ? (
                    fleetDetails.map((row, index) => (
                      <TableRow
                        key={row.id || index}
                        sx={{
                          backgroundColor:
                            index % 2 !== 0
                              ? "#d8e9ee"
                              : "var(--ty-white-color)",
                          td: { border: 0, padding: "10px 8px" },
                        }}
                      >
                        <TableCell>
                          <Typography variant="p" className="MuiTypography-p">
                            {row.fleet}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="p" className="MuiTypography-p">
                            {row.hr || "00"}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="p" className="MuiTypography-p">
                            {row.min || "00"}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="p" className="MuiTypography-p">
                            {row.sec || "00"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow
                      sx={{
                        background: "rgba(255, 255, 255, 0.38)",
                        width: "100%",
                        height: "100px",
                      }}
                    >
                      <TableCell
                        colSpan={4}
                        align="center"
                        sx={{ padding: "24px" }}
                        className="ty_no-row-data"
                      >
                        No fleet data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions
          className="dialog_footer"
          sx={{ justifyContent: "space-between" }}
        >
          <Box>
            <Button
              onClick={onClose}
              disabled={processing}
              variant="contained"
              className="ty_secondary_btn"
            >
              Close
            </Button>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button
              onClick={onUpdateStartTime}
              disabled={processing}
              variant="contained"
              className="ty_secondary_btn"
            >
              Cancel and Update Start Time
            </Button>
            <Button
              variant="contained"
              autoFocus
              onClick={onProceed}
              disabled={processing}
              className="ty_primary_btn"
            >
              Proceed
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default React.memo(StartTimeConfirmModal);
